import React from 'react';
import PropTypes from 'prop-types';

import FreeShipAlt from '../FreeShipAlt/FreeShipAlt';
import { StyledDiv, StyledHeaderContainer, StyledTitle } from './CartDrawerHeaderAltStyles';

var CartDrawerHeaderAlt = function CartDrawerHeaderAlt(props) {
  return React.createElement(
    StyledDiv,
    null,
    React.createElement(
      StyledHeaderContainer,
      null,
      React.createElement(
        StyledTitle,
        null,
        'Your Cart',
        ' ',
        React.createElement(
          'span',
          null,
          '(',
          props.cartQuantity,
          ')'
        )
      ),
      React.createElement(FreeShipAlt, {
        subtotalPrice: props.checkout.subtotalPriceV2.amount,
        discountThresholdAmount: props.discountThresholdAmount
      })
    )
  );
};

CartDrawerHeaderAlt.propTypes = {
  checkout: PropTypes.object.isRequired,
  webUrl: PropTypes.string,
  cartQuantity: PropTypes.number,
  handleCartClose: PropTypes.func,
  addCheckoutNote: PropTypes.func.isRequired,
  checkoutNote: PropTypes.string,
  addPlusReleaseDate: PropTypes.func.isRequired,
  checkoutCustomAttributes: PropTypes.array,
  noVendorItems: PropTypes.bool,
  addDiscountCode: PropTypes.func.isRequired,
  removeDiscountCode: PropTypes.func.isRequired,
  checkoutDiscountCodes: PropTypes.object,
  autoDiscountPromo: PropTypes.bool,
  autoDiscountCode: PropTypes.string,
  autoDiscountCodeEndDate: PropTypes.string,
  formSubmitted: PropTypes.bool,
  formDiscountCode: PropTypes.string,
  discountThresholdAmount: PropTypes.string
};

export default CartDrawerHeaderAlt;